// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"e4b6e0dd","180":"39df81b2","198":"67077e63","208":"c4d5c46d","631":"83712cf8","703":"0d622fd9","774":"717f6bd0","787":"95b0c1cd","820":"5ce26067","910":"42495d30"}[chunkId] + ".chunk.js";
};